import { Project } from '@dc-shared-web/hooks/api/project/types'
import { UpdateProjectParams } from '@dc-shared-web/hooks/api/project/useUpdateProject'
import { snakeCaseToCamelCase } from '@dc-shared-web/lib/utils'
import { AxiosInstance } from 'axios'

export const updateProject = async (
  apiClient: AxiosInstance,
  params: UpdateProjectParams
): Promise<Project> => {
  const {
    data: { data },
  } = await apiClient.patch(`/api/project-info/${params.id}`, {
    [snakeCaseToCamelCase(params.field)]: params.value,
  })

  return data
}
